/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 814:
/***/ (function() {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UpsellsNoteValidation = function (_HTMLElement) {
  _inherits(UpsellsNoteValidation, _HTMLElement);

  var _super = _createSuper(UpsellsNoteValidation);

  function UpsellsNoteValidation() {
    var _this;

    _classCallCheck(this, UpsellsNoteValidation);

    _this = _super.call(this);
    _this.boundValidate = _this.validate.bind(_assertThisInitialized(_this));
    _this.boundOnVariantChange = _this.onVariantChange.bind(_assertThisInitialized(_this));
    _this.boundOnButtonClick = _this.onButtonClick.bind(_assertThisInitialized(_this));
    _this.boundOnCartAdd = _this.onCartAdd.bind(_assertThisInitialized(_this));
    _this.boundOnBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.hasAttemptedSubmit = false;
    _this.hasBlurred = false;
    _this.initialCheckboxStates = new Map();
    return _this;
  }

  _createClass(UpsellsNoteValidation, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.cleanup();
    }
  }, {
    key: "productFormId",
    get: function get() {
      return this.getAttribute('data-product-form-id');
    }
  }, {
    key: "mandatoryNoteSetting",
    get: function get() {
      return this.getAttribute('data-mandatory-note') || 'always';
    }
  }, {
    key: "noteAutofocus",
    get: function get() {
      return this.getAttribute('data-note-autofocus') === 'true';
    }
  }, {
    key: "textarea",
    get: function get() {
      return this._textarea = this._textarea || this.querySelector('#upsells-note');
    }
  }, {
    key: "hiddenInput",
    get: function get() {
      return this._hiddenInput = this._hiddenInput || this.querySelector('#upsells-note-hidden');
    }
  }, {
    key: "errorMessage",
    get: function get() {
      return this._errorMessage = this._errorMessage || this.querySelector('[data-upsells-selector="note-error"]');
    }
  }, {
    key: "noteSection",
    get: function get() {
      return this._noteSection = this._noteSection || this.querySelector('[data-note-section]');
    }
  }, {
    key: "dynamicCheckoutButtons",
    get: function get() {
      var form = document.getElementById(this.productFormId);
      return form ? Array.from(form.querySelectorAll('.shopify-payment-button')) : [];
    }
  }, {
    key: "checkboxes",
    get: function get() {
      return Array.from(document.querySelectorAll("[form=\"".concat(this.productFormId, "\"] input[name=\"bundles\"]")));
    }
  }, {
    key: "submitButtons",
    get: function get() {
      return this._submitButtons = this._submitButtons || [].concat(_toConsumableArray(Array.from(document.querySelectorAll("[type=\"submit\"][form=\"".concat(this.productFormId, "\"]")))), _toConsumableArray(Array.from(document.querySelectorAll("form#".concat(this.productFormId, " [type=\"submit\"]")))));
    }
  }, {
    key: "minLength",
    get: function get() {
      var _this$textarea;

      return parseInt((_this$textarea = this.textarea) === null || _this$textarea === void 0 ? void 0 : _this$textarea.getAttribute('data-min-length')) || 1;
    }
  }, {
    key: "maxLength",
    get: function get() {
      var _this$textarea2;

      var max = parseInt((_this$textarea2 = this.textarea) === null || _this$textarea2 === void 0 ? void 0 : _this$textarea2.getAttribute('data-max-length')) || 0;
      return max > 0 ? max : null;
    }
  }, {
    key: "validationMessage",
    get: function get() {
      var _this$textarea3;

      return ((_this$textarea3 = this.textarea) === null || _this$textarea3 === void 0 ? void 0 : _this$textarea3.getAttribute('data-validation-message')) || 'Please fill in the note field';
    }
  }, {
    key: "hasSelectedUpsells",
    get: function get() {
      return this.checkboxes.some(function (checkbox) {
        return checkbox.checked;
      });
    }
  }, {
    key: "noteValue",
    get: function get() {
      var _this$textarea4;

      return ((_this$textarea4 = this.textarea) === null || _this$textarea4 === void 0 ? void 0 : _this$textarea4.value.trim()) || '';
    }
  }, {
    key: "isNoteValid",
    get: function get() {
      var value = this.noteValue;
      var length = value.length;

      if (length < this.minLength) {
        return false;
      }

      if (this.maxLength && length > this.maxLength) {
        return false;
      }

      return true;
    }
  }, {
    key: "hasAnyMandatoryNoteProducts",
    get: function get() {
      return this.checkboxes.some(function (checkbox) {
        var tags = checkbox.dataset.productTags || '';
        return tags.includes('MandatoryNote');
      });
    }
  }, {
    key: "shouldShowNote",
    get: function get() {
      if (!this.noteSection) return false;

      if (this.mandatoryNoteSetting === 'always') {
        return true;
      }

      if (this.mandatoryNoteSetting === 'on_selection') {
        return this.checkboxes.some(function (checkbox) {
          if (!checkbox.checked) return false;
          var tags = checkbox.dataset.productTags || '';
          return tags.includes('MandatoryNote');
        });
      }

      return false;
    }
  }, {
    key: "shouldValidate",
    get: function get() {
      if (!this.shouldShowNote) {
        return false;
      }

      var selectedCheckboxes = this.checkboxes.filter(function (checkbox) {
        return checkbox.checked;
      });
      return selectedCheckboxes.some(function (checkbox) {
        var tags = checkbox.dataset.productTags || '';
        return tags.includes('MandatoryNote');
      });
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      if (!this.textarea) {
        console.warn('UpsellsNoteValidation: textarea not found');
        return;
      }

      this.checkboxes.forEach(function (checkbox) {
        _this2.initialCheckboxStates.set(checkbox.id, checkbox.checked);
      });
      this.attachEventListeners();
      this.validate();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      var _this3 = this;

      this.textarea.addEventListener('input', this.boundValidate);
      this.textarea.addEventListener('blur', this.boundOnBlur);
      this.checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', _this3.boundValidate);
      });
      this.submitButtons.forEach(function (button) {
        button.addEventListener('click', _this3.boundOnButtonClick);
      });
      document.addEventListener('variant:change', this.boundOnVariantChange);
      document.addEventListener('ajaxProduct:added', this.boundOnCartAdd);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this4 = this;

      if (this.textarea) {
        this.textarea.removeEventListener('input', this.boundValidate);
        this.textarea.removeEventListener('blur', this.boundOnBlur);
      }

      this.checkboxes.forEach(function (checkbox) {
        checkbox.removeEventListener('change', _this4.boundValidate);
      });
      this.submitButtons.forEach(function (button) {
        button.removeEventListener('click', _this4.boundOnButtonClick);
      });
      document.removeEventListener('variant:change', this.boundOnVariantChange);
      document.removeEventListener('ajaxProduct:added', this.boundOnCartAdd);
    }
  }, {
    key: "onButtonClick",
    value: function onButtonClick(event) {
      var shouldValidate = this.shouldValidate;
      var isValid = this.isNoteValid;

      if (shouldValidate && !isValid) {
        this.hasAttemptedSubmit = true;
        event.preventDefault();
        this.validate();
        this.showErrorMessage();
        this.scrollToTextarea();
      }
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange() {
      this.validate();
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.hasBlurred = true;
      this.validate();
    }
  }, {
    key: "onCartAdd",
    value: function onCartAdd(event) {
      this.resetForm();
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      var _this5 = this;

      if (this.textarea) {
        this.textarea.value = '';
      }

      this.checkboxes.forEach(function (checkbox) {
        var initialState = _this5.initialCheckboxStates.get(checkbox.id);

        checkbox.checked = initialState !== undefined ? initialState : false;
      });
      this.hasAttemptedSubmit = false;
      this.hasBlurred = false;

      if (this.textarea) {
        this.textarea.classList.remove('note-invalid', 'note-valid');
        this.textarea.removeAttribute('aria-invalid');
      }

      this.hideErrorMessage();
      this.validate();
    }
  }, {
    key: "validate",
    value: function validate() {
      this.updateNoteVisibility();

      if (!this.shouldShowNote) {
        this.updateButtonStates(false, true);
        this.syncHiddenInput();
        return;
      }

      var shouldValidate = this.shouldValidate;
      var isValid = this.isNoteValid;
      this.updateTextareaFeedback(shouldValidate, isValid);

      if (isValid || !shouldValidate) {
        this.hideErrorMessage();
      }

      this.syncHiddenInput();
      this.updateButtonStates(shouldValidate, isValid);
      this.dispatchEvent(new CustomEvent('upsells-note:validate', {
        bubbles: true,
        detail: {
          shouldValidate: shouldValidate,
          isValid: isValid,
          noteValue: this.noteValue,
          isVisible: this.shouldShowNote
        }
      }));
    }
  }, {
    key: "updateNoteVisibility",
    value: function updateNoteVisibility() {
      var _this6 = this;

      if (!this.noteSection) return;
      var shouldShow = this.shouldShowNote;
      var isCurrentlyVisible = this.noteSection.style.display !== 'none';
      if (shouldShow === isCurrentlyVisible) return;

      if (shouldShow) {
        this.noteSection.style.display = '';

        if (this.noteAutofocus && this.textarea) {
          setTimeout(function () {
            _this6.textarea.focus();
          }, 150);
        }
      } else {
        this.noteSection.style.display = 'none';

        if (this.textarea) {
          this.textarea.value = '';
          this.textarea.classList.remove('note-invalid', 'note-valid');
          this.textarea.removeAttribute('aria-invalid');
        }

        this.hasAttemptedSubmit = false;
        this.hasBlurred = false;
        this.hideErrorMessage();
      }
    }
  }, {
    key: "updateTextareaFeedback",
    value: function updateTextareaFeedback(shouldValidate, isValid) {
      if (!this.textarea) return;
      var shouldShowFeedback = this.hasAttemptedSubmit || this.hasBlurred && this.noteValue.length > 0;

      if (shouldValidate && !isValid && shouldShowFeedback) {
        this.textarea.classList.add('note-invalid');
        this.textarea.classList.remove('note-valid');
        this.textarea.setAttribute('aria-invalid', 'true');
      } else if (shouldValidate && isValid) {
        this.textarea.classList.remove('note-invalid');
        this.textarea.classList.add('note-valid');
        this.textarea.removeAttribute('aria-invalid');
      } else {
        this.textarea.classList.remove('note-invalid', 'note-valid');
        this.textarea.removeAttribute('aria-invalid');
      }
    }
  }, {
    key: "syncHiddenInput",
    value: function syncHiddenInput() {
      if (!this.hiddenInput) return;
      var selectedUpsells = this.getSelectedUpsellsInfo();
      var finalValue = '';

      if (selectedUpsells.length > 0) {
        var productsText = selectedUpsells.map(function (upsell) {
          var variantInfo = upsell.variantTitle && upsell.variantTitle !== 'Default Title' ? " (".concat(upsell.variantTitle, ")") : '';
          return "".concat(upsell.productTitle).concat(variantInfo);
        }).join(', ');
        finalValue = "Products: ".concat(productsText);
        var variantIds = selectedUpsells.map(function (u) {
          return u.variantId;
        }).join(', ');
        finalValue += " [IDs: ".concat(variantIds, "]");

        if (this.noteValue) {
          finalValue += " | Note: ".concat(this.noteValue);
        }
      } else {
        finalValue = this.noteValue;
      }

      if (this.hiddenInput) {
        this.hiddenInput.value = finalValue;
      }
    }
  }, {
    key: "getSelectedUpsellsInfo",
    value: function getSelectedUpsellsInfo() {
      var selectedCheckboxes = this.checkboxes.filter(function (checkbox) {
        return checkbox.checked;
      });
      return selectedCheckboxes.map(function (checkbox) {
        return {
          variantId: checkbox.value,
          productTitle: checkbox.getAttribute('data-product-title') || 'Unknown Product',
          variantTitle: checkbox.getAttribute('data-variant-title') || 'Default Title'
        };
      });
    }
  }, {
    key: "updateButtonStates",
    value: function updateButtonStates(shouldValidate, isValid) {
      var _this7 = this;

      var shouldDisable = shouldValidate && !isValid;
      this.submitButtons.forEach(function (button) {
        if (shouldDisable) {
          button.setAttribute('data-note-pending', 'true');

          _this7.updateButtonText(button, true);
        } else {
          button.setAttribute('data-note-pending', 'false');

          _this7.updateButtonText(button, false);
        }
      });
      this.dynamicCheckoutButtons.forEach(function (buttonContainer) {
        if (shouldDisable) {
          buttonContainer.setAttribute('data-note-pending', 'true');
        } else {
          buttonContainer.setAttribute('data-note-pending', 'false');
        }
      });
    }
  }, {
    key: "updateButtonText",
    value: function updateButtonText(button, isPending) {
      var textElement = button.querySelector('.btn-text > span') || button.querySelector('.btn-text');
      if (!textElement) return;

      if (isPending) {
        var _window$theme, _window$theme$variant;

        var requiresNoteText = ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$variant = _window$theme.variantStrings) === null || _window$theme$variant === void 0 ? void 0 : _window$theme$variant.requiresNote) || 'Requires note';
        textElement.textContent = requiresNoteText;
      } else {
        var _window$theme2, _window$theme2$varian, _window$theme3, _window$theme3$varian;

        var originalText = button.hasAttribute('data-pre-order') ? ((_window$theme2 = window.theme) === null || _window$theme2 === void 0 ? void 0 : (_window$theme2$varian = _window$theme2.variantStrings) === null || _window$theme2$varian === void 0 ? void 0 : _window$theme2$varian.preOrder) || 'Pre-order' : ((_window$theme3 = window.theme) === null || _window$theme3 === void 0 ? void 0 : (_window$theme3$varian = _window$theme3.variantStrings) === null || _window$theme3$varian === void 0 ? void 0 : _window$theme3$varian.addToCart) || 'Add to cart';

        if (!button.hasAttribute('disabled')) {
          textElement.textContent = originalText;
        }
      }
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage() {
      if (!this.errorMessage) return;
      var errorTemplate = this.errorMessage.getAttribute('data-error-template') || 'The note must be at least {{ min_length }} characters long';
      var errorText = errorTemplate.replace('{{ min_length }}', this.minLength);
      this.errorMessage.textContent = errorText;
      this.errorMessage.style.display = 'block';
    }
  }, {
    key: "hideErrorMessage",
    value: function hideErrorMessage() {
      if (!this.errorMessage) return;
      this.errorMessage.style.display = 'none';
    }
  }, {
    key: "scrollToTextarea",
    value: function scrollToTextarea() {
      var _this8 = this;

      if (!this.textarea) return;
      this.textarea.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      setTimeout(function () {
        _this8.textarea.focus();
      }, 300);
    }
  }]);

  return UpsellsNoteValidation;
}(_wrapNativeSuper(HTMLElement));

if (!customElements.get('upsells-note-validation')) {
  customElements.define('upsells-note-validation', UpsellsNoteValidation);
}

document.addEventListener('DOMContentLoaded', function () {
  var existingElements = document.querySelectorAll('[data-upsells-note-validation]');
  existingElements.forEach(function (element) {
    if (!element.tagName.includes('-')) {
      var textarea = element.querySelector('#upsells-note');

      if (textarea) {
        textarea.dispatchEvent(new Event('input'));
      }
    }
  });
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// EXTERNAL MODULE: ./js/sections/upsells-note-validation.js
var upsells_note_validation = __webpack_require__(814);
;// CONCATENATED MODULE: ./js/sections/cart-upsells.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CartUpsells = function (_HTMLElement) {
  _inherits(CartUpsells, _HTMLElement);

  var _super = _createSuper(CartUpsells);

  function CartUpsells() {
    var _this;

    _classCallCheck(this, CartUpsells);

    _this = _super.call(this);
    _this.boundOnCartUpdate = _this.onCartUpdate.bind(_assertThisInitialized(_this));
    _this.boundOnProductAdded = _this.onProductAdded.bind(_assertThisInitialized(_this));
    _this.boundOnDrawerOpen = _this.onDrawerOpen.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CartUpsells, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.cleanup();
    }
  }, {
    key: "init",
    value: function init() {
      document.addEventListener('cart:updated', this.boundOnCartUpdate);
      document.addEventListener('ajaxProduct:added', this.boundOnProductAdded);
      document.addEventListener('drawer:afterShow', this.boundOnDrawerOpen);
      var productRecs = this.querySelector('product-recommendations');

      if (productRecs) {
        productRecs.addEventListener('recommendations:loaded', this.boundOnDrawerOpen);
      }
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      document.removeEventListener('cart:updated', this.boundOnCartUpdate);
      document.removeEventListener('ajaxProduct:added', this.boundOnProductAdded);
      document.removeEventListener('drawer:afterShow', this.boundOnDrawerOpen);
      var productRecs = this.querySelector('product-recommendations');

      if (productRecs) {
        productRecs.removeEventListener('recommendations:loaded', this.boundOnDrawerOpen);
      }
    }
  }, {
    key: "onDrawerOpen",
    value: function onDrawerOpen(event) {
      this.resizeCarousel();
    }
  }, {
    key: "onCartUpdate",
    value: function onCartUpdate(event) {
      this.refreshUpsells();
    }
  }, {
    key: "onProductAdded",
    value: function onProductAdded(event) {
      this.refreshUpsells();
    }
  }, {
    key: "refreshUpsells",
    value: function () {
      var _refreshUpsells = _asyncToGenerator(_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;

        var sectionId, isDrawer, response, html, parser, doc, newCartUpsells;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                sectionId = this.dataset.sectionId;

                if (sectionId) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                isDrawer = this.closest('.cart-drawer') !== null;
                _context.next = 7;
                return fetch("".concat(window.Shopify.routes.root, "?section_id=").concat(sectionId));

              case 7:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 10;
                  break;
                }

                throw new Error('Failed to fetch section');

              case 10:
                _context.next = 12;
                return response.text();

              case 12:
                html = _context.sent;
                parser = new DOMParser();
                doc = parser.parseFromString(html, 'text/html');
                newCartUpsells = doc.querySelector('cart-upsells');

                if (newCartUpsells) {
                  this.innerHTML = newCartUpsells.innerHTML;
                  setTimeout(function () {
                    _this2.resizeCarousel();
                  }, 100);
                } else {
                  this.style.display = 'none';
                }

                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                console.error('Error refreshing cart upsells:', _context.t0);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 19]]);
      }));

      function refreshUpsells() {
        return _refreshUpsells.apply(this, arguments);
      }

      return refreshUpsells;
    }()
  }, {
    key: "resizeCarousel",
    value: function resizeCarousel() {
      var complementary = this.querySelector('product-complementary');

      if (complementary && complementary.carousel && complementary.carousel.slider) {
        complementary.carousel.slider.resize();
      }
    }
  }]);

  return CartUpsells;
}(_wrapNativeSuper(HTMLElement));

if (!customElements.get('cart-upsells')) {
  customElements.define('cart-upsells', CartUpsells);
}

/* harmony default export */ var cart_upsells = ((/* unused pure expression or super */ null && (CartUpsells)));
;// CONCATENATED MODULE: ./js/sections/cart-upsell-note.js
function cart_upsell_note_typeof(obj) { "@babel/helpers - typeof"; return cart_upsell_note_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, cart_upsell_note_typeof(obj); }

function cart_upsell_note_regeneratorRuntime() { "use strict"; cart_upsell_note_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == cart_upsell_note_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function cart_upsell_note_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function cart_upsell_note_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { cart_upsell_note_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { cart_upsell_note_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function cart_upsell_note_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cart_upsell_note_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function cart_upsell_note_createClass(Constructor, protoProps, staticProps) { if (protoProps) cart_upsell_note_defineProperties(Constructor.prototype, protoProps); if (staticProps) cart_upsell_note_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function cart_upsell_note_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) cart_upsell_note_setPrototypeOf(subClass, superClass); }

function cart_upsell_note_createSuper(Derived) { var hasNativeReflectConstruct = cart_upsell_note_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = cart_upsell_note_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = cart_upsell_note_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return cart_upsell_note_possibleConstructorReturn(this, result); }; }

function cart_upsell_note_possibleConstructorReturn(self, call) { if (call && (cart_upsell_note_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cart_upsell_note_assertThisInitialized(self); }

function cart_upsell_note_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function cart_upsell_note_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; cart_upsell_note_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !cart_upsell_note_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return cart_upsell_note_construct(Class, arguments, cart_upsell_note_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return cart_upsell_note_setPrototypeOf(Wrapper, Class); }; return cart_upsell_note_wrapNativeSuper(Class); }

function cart_upsell_note_construct(Parent, args, Class) { if (cart_upsell_note_isNativeReflectConstruct()) { cart_upsell_note_construct = Reflect.construct.bind(); } else { cart_upsell_note_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) cart_upsell_note_setPrototypeOf(instance, Class.prototype); return instance; }; } return cart_upsell_note_construct.apply(null, arguments); }

function cart_upsell_note_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function cart_upsell_note_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function cart_upsell_note_setPrototypeOf(o, p) { cart_upsell_note_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cart_upsell_note_setPrototypeOf(o, p); }

function cart_upsell_note_getPrototypeOf(o) { cart_upsell_note_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cart_upsell_note_getPrototypeOf(o); }

var CartUpsellNote = function (_HTMLElement) {
  cart_upsell_note_inherits(CartUpsellNote, _HTMLElement);

  var _super = cart_upsell_note_createSuper(CartUpsellNote);

  function CartUpsellNote() {
    var _this;

    cart_upsell_note_classCallCheck(this, CartUpsellNote);

    _this = _super.call(this);
    _this.boundValidate = _this.validate.bind(cart_upsell_note_assertThisInitialized(_this));
    _this.boundOnSave = _this.onSave.bind(cart_upsell_note_assertThisInitialized(_this));
    _this.boundOnBlur = _this.onBlur.bind(cart_upsell_note_assertThisInitialized(_this));
    _this.boundOnCartUpdate = _this.onCartUpdate.bind(cart_upsell_note_assertThisInitialized(_this));
    _this.boundOnProductAdded = _this.onProductAdded.bind(cart_upsell_note_assertThisInitialized(_this));
    _this.boundBeforeModalClose = _this.beforeModalClose.bind(cart_upsell_note_assertThisInitialized(_this));
    _this.hasAttemptedSave = false;
    _this.hasBlurred = false;
    _this.isSaving = false;
    _this.hasMandatoryItem = false;
    _this.allowClose = false;
    return _this;
  }

  cart_upsell_note_createClass(CartUpsellNote, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.cleanup();
    }
  }, {
    key: "sectionId",
    get: function get() {
      return this.getAttribute('data-section-id');
    }
  }, {
    key: "textarea",
    get: function get() {
      return this._textarea = this._textarea || this.querySelector('textarea[name="upsell-note"]');
    }
  }, {
    key: "errorMessage",
    get: function get() {
      return this._errorMessage = this._errorMessage || this.querySelector('.upsells-note-error');
    }
  }, {
    key: "saveButton",
    get: function get() {
      return this._saveButton = this._saveButton || this.querySelector('button[type="button"]');
    }
  }, {
    key: "checkoutButton",
    get: function get() {
      return document.querySelector('button[name="checkout"]');
    }
  }, {
    key: "minLength",
    get: function get() {
      var _window$theme, _window$theme$upsellN, _this$textarea;

      return ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$upsellN = _window$theme.upsellNoteSettings) === null || _window$theme$upsellN === void 0 ? void 0 : _window$theme$upsellN.minLength) || parseInt((_this$textarea = this.textarea) === null || _this$textarea === void 0 ? void 0 : _this$textarea.getAttribute('data-min-length')) || 10;
    }
  }, {
    key: "maxLength",
    get: function get() {
      var _window$theme2, _window$theme2$upsell, _this$textarea2;

      var max = ((_window$theme2 = window.theme) === null || _window$theme2 === void 0 ? void 0 : (_window$theme2$upsell = _window$theme2.upsellNoteSettings) === null || _window$theme2$upsell === void 0 ? void 0 : _window$theme2$upsell.maxLength) || parseInt((_this$textarea2 = this.textarea) === null || _this$textarea2 === void 0 ? void 0 : _this$textarea2.getAttribute('data-max-length')) || 0;
      return max > 0 ? max : null;
    }
  }, {
    key: "modal",
    get: function get() {
      return this._modal = this._modal || this.closest('modal-element');
    }
  }, {
    key: "noteValue",
    get: function get() {
      var _this$textarea3;

      return ((_this$textarea3 = this.textarea) === null || _this$textarea3 === void 0 ? void 0 : _this$textarea3.value.trim()) || '';
    }
  }, {
    key: "isNoteValid",
    get: function get() {
      var value = this.noteValue;
      var length = value.length;

      if (length < this.minLength) {
        return false;
      }

      if (this.maxLength && length > this.maxLength) {
        return false;
      }

      return true;
    }
  }, {
    key: "getMandatoryNoteItem",
    value: function () {
      var _getMandatoryNoteItem = cart_upsell_note_asyncToGenerator(cart_upsell_note_regeneratorRuntime().mark(function _callee() {
        var response, cart;
        return cart_upsell_note_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch("".concat(theme.routes.cart_url, "?view=json"), _objectSpread({}, theme.utils.fetchConfig('json', 'GET')));

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                cart = _context.sent;
                return _context.abrupt("return", cart.items.find(function (item) {
                  var isServiceUpsell = item.properties && item.properties._type === 'service';
                  return isServiceUpsell;
                }));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                console.error('Error fetching cart:', _context.t0);
                return _context.abrupt("return", null);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 10]]);
      }));

      function getMandatoryNoteItem() {
        return _getMandatoryNoteItem.apply(this, arguments);
      }

      return getMandatoryNoteItem;
    }()
  }, {
    key: "init",
    value: function init() {
      if (!this.textarea) {
        console.warn('CartUpsellNote: textarea not found');
        return;
      }

      this.attachEventListeners();
      this.loadExistingNote();
      this.validate();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      this.textarea.addEventListener('input', this.boundValidate);
      this.textarea.addEventListener('blur', this.boundOnBlur);

      if (this.saveButton) {
        this.saveButton.addEventListener('click', this.boundOnSave);
      }

      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.boundOnCartUpdate);
      document.addEventListener('ajaxProduct:added', this.boundOnProductAdded);
      this.setupModalCloseIntercept();
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.textarea) {
        this.textarea.removeEventListener('input', this.boundValidate);
        this.textarea.removeEventListener('blur', this.boundOnBlur);
      }

      if (this.saveButton) {
        this.saveButton.removeEventListener('click', this.boundOnSave);
      }

      document.removeEventListener('ajaxProduct:added', this.boundOnProductAdded);
      this.cleanupModalCloseIntercept();
    }
  }, {
    key: "loadExistingNote",
    value: function () {
      var _loadExistingNote = cart_upsell_note_asyncToGenerator(cart_upsell_note_regeneratorRuntime().mark(function _callee2() {
        var item;
        return cart_upsell_note_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getMandatoryNoteItem();

              case 2:
                item = _context2.sent;
                this.hasMandatoryItem = !!item;

                if (item && item.properties && item.properties._upsell_note) {
                  this.textarea.value = item.properties._upsell_note;
                  this.validate();
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadExistingNote() {
        return _loadExistingNote.apply(this, arguments);
      }

      return loadExistingNote;
    }()
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.hasBlurred = true;
      this.validate();
    }
  }, {
    key: "onCartUpdate",
    value: function () {
      var _onCartUpdate = cart_upsell_note_asyncToGenerator(cart_upsell_note_regeneratorRuntime().mark(function _callee3(event) {
        return cart_upsell_note_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.loadExistingNote();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onCartUpdate(_x) {
        return _onCartUpdate.apply(this, arguments);
      }

      return onCartUpdate;
    }()
  }, {
    key: "onProductAdded",
    value: function () {
      var _onProductAdded = cart_upsell_note_asyncToGenerator(cart_upsell_note_regeneratorRuntime().mark(function _callee5(event) {
        var _this2 = this;

        var _ref, product, properties, isServiceUpsell;

        return cart_upsell_note_regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _ref = event.detail || {}, product = _ref.product;

                if (product) {
                  _context5.next = 3;
                  break;
                }

                return _context5.abrupt("return");

              case 3:
                properties = event.detail.product.properties || {};
                isServiceUpsell = properties._type === 'service';

                if (isServiceUpsell) {
                  setTimeout(cart_upsell_note_asyncToGenerator(cart_upsell_note_regeneratorRuntime().mark(function _callee4() {
                    return cart_upsell_note_regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _this2.loadExistingNote();

                          case 2:
                            _this2.openModal();

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  })), 300);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function onProductAdded(_x2) {
        return _onProductAdded.apply(this, arguments);
      }

      return onProductAdded;
    }()
  }, {
    key: "openModal",
    value: function openModal() {
      if (!this.modal) return;
      var trigger = document.querySelector("[aria-controls=\"".concat(this.modal.id, "\"]"));

      if (trigger) {
        trigger.click();
      } else if (this.modal.show) {
        this.modal.show();
      }
    }
  }, {
    key: "setupModalCloseIntercept",
    value: function setupModalCloseIntercept() {
      var _this3 = this;

      if (!this.modal) return;
      this.closeControls = Array.from(this.modal.querySelectorAll('[aria-controls][aria-expanded]'));
      this.closeControls.forEach(function (control) {
        control.addEventListener('click', _this3.boundBeforeModalClose, true);
      });
      this.modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          _this3.beforeModalClose(e);
        }
      }, true);
    }
  }, {
    key: "cleanupModalCloseIntercept",
    value: function cleanupModalCloseIntercept() {
      var _this4 = this;

      if (this.closeControls) {
        this.closeControls.forEach(function (control) {
          control.removeEventListener('click', _this4.boundBeforeModalClose, true);
        });
      }
    }
  }, {
    key: "beforeModalClose",
    value: function beforeModalClose(event) {
      if (this.allowClose) {
        this.allowClose = false;
        return;
      }

      if (!this.hasMandatoryItem) {
        return;
      }

      var isValid = this.isNoteValid;

      if (!isValid) {
        if (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        this.hasAttemptedSave = true;
        this.validate();
        var errorMessage = (theme.strings.upsellNoteClosePrevented || 'Please complete the note before closing (minimum {{ min_length }} characters)').replace('{{ min_length }}', this.minLength);
        this.showErrorMessage(errorMessage);

        if (this.textarea) {
          this.textarea.focus();
        }

        return;
      }
    }
  }, {
    key: "onSave",
    value: function () {
      var _onSave = cart_upsell_note_asyncToGenerator(cart_upsell_note_regeneratorRuntime().mark(function _callee6(event) {
        var isValid, item, sectionsToBundle, body, response, cart;
        return cart_upsell_note_regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                event.preventDefault();
                this.hasAttemptedSave = true;
                isValid = this.isNoteValid;

                if (isValid) {
                  _context6.next = 7;
                  break;
                }

                this.validate();
                this.showErrorMessage();
                return _context6.abrupt("return");

              case 7:
                if (!this.isSaving) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return");

              case 9:
                this.isSaving = true;
                _context6.prev = 10;
                console.log('onSave');
                _context6.next = 14;
                return this.getMandatoryNoteItem();

              case 14:
                item = _context6.sent;

                if (item) {
                  _context6.next = 17;
                  break;
                }

                throw new Error('No MandatoryNote item found in cart');

              case 17:
                sectionsToBundle = [];
                document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
                  bubbles: true,
                  detail: {
                    sections: sectionsToBundle
                  }
                }));
                body = JSON.stringify({
                  id: item.key,
                  properties: _objectSpread(_objectSpread({}, item.properties), {}, {
                    _upsell_note: this.noteValue
                  }),
                  sections: sectionsToBundle,
                  sections_url: window.location.pathname
                });
                _context6.next = 22;
                return fetch(theme.routes.cart_change_url, _objectSpread(_objectSpread({}, theme.utils.fetchConfig()), {}, {
                  body: body
                }));

              case 22:
                response = _context6.sent;

                if (response.ok) {
                  _context6.next = 25;
                  break;
                }

                throw new Error('Failed to update cart');

              case 25:
                _context6.next = 27;
                return response.json();

              case 27:
                cart = _context6.sent;
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'cart-upsell-note',
                  cart: cart
                });
                this.allowClose = true;

                if (this.modal && typeof this.modal.hide === 'function') {
                  this.modal.hide();
                }

                this.showSuccessFeedback();
                _context6.next = 38;
                break;

              case 34:
                _context6.prev = 34;
                _context6.t0 = _context6["catch"](10);
                console.error('Error saving upsell note:', _context6.t0);
                this.showErrorMessage('Failed to save note. Please try again.');

              case 38:
                _context6.prev = 38;
                this.isSaving = false;
                return _context6.finish(38);

              case 41:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[10, 34, 38, 41]]);
      }));

      function onSave(_x3) {
        return _onSave.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: "validate",
    value: function validate() {
      var isValid = this.isNoteValid;
      this.updateTextareaFeedback(isValid);

      if (isValid) {
        this.hideErrorMessage();
      }

      this.updateCheckoutButton(isValid);
      this.updateSaveButton(isValid);
    }
  }, {
    key: "updateTextareaFeedback",
    value: function updateTextareaFeedback(isValid) {
      if (!this.textarea) return;
      var shouldShowFeedback = this.hasAttemptedSave || this.hasBlurred && this.noteValue.length > 0;

      if (!isValid && shouldShowFeedback) {
        this.textarea.classList.add('note-invalid');
        this.textarea.classList.remove('note-valid');
        this.textarea.setAttribute('aria-invalid', 'true');
      } else if (isValid && this.noteValue.length > 0) {
        this.textarea.classList.remove('note-invalid');
        this.textarea.classList.add('note-valid');
        this.textarea.removeAttribute('aria-invalid');
      } else {
        this.textarea.classList.remove('note-invalid', 'note-valid');
        this.textarea.removeAttribute('aria-invalid');
      }
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage() {
      var customMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!this.errorMessage) return;
      var errorText = customMessage || (theme.strings.upsellNoteError || 'The note must be at least {{ min_length }} characters long').replace('{{ min_length }}', this.minLength);
      this.errorMessage.textContent = errorText;
      this.errorMessage.style.display = 'block';
    }
  }, {
    key: "hideErrorMessage",
    value: function hideErrorMessage() {
      if (!this.errorMessage) return;
      this.errorMessage.style.display = 'none';
    }
  }, {
    key: "showSuccessFeedback",
    value: function showSuccessFeedback() {
      if (this.saveButton) {
        var _this$saveButton$quer;

        var originalText = (_this$saveButton$quer = this.saveButton.querySelector('.btn-text')) === null || _this$saveButton$quer === void 0 ? void 0 : _this$saveButton$quer.textContent;
        var btnText = this.saveButton.querySelector('.btn-text');

        if (btnText) {
          btnText.textContent = theme.strings.saved || 'Saved!';
          setTimeout(function () {
            btnText.textContent = originalText;
          }, 2000);
        }
      }
    }
  }, {
    key: "updateCheckoutButton",
    value: function updateCheckoutButton(isValid) {
      if (!this.checkoutButton) return;

      if (this.hasMandatoryItem) {
        if (isValid) {
          this.checkoutButton.removeAttribute('disabled');
          this.checkoutButton.removeAttribute('data-upsell-note-pending');
        } else {
          this.checkoutButton.setAttribute('disabled', 'disabled');
          this.checkoutButton.setAttribute('data-upsell-note-pending', 'true');
        }
      }
    }
  }, {
    key: "updateSaveButton",
    value: function updateSaveButton(isValid) {
      if (!this.saveButton) return;

      if (this.isSaving) {
        this.saveButton.setAttribute('disabled', 'disabled');
      } else if (!isValid && this.hasAttemptedSave) {
        this.saveButton.setAttribute('disabled', 'disabled');
      } else {
        this.saveButton.removeAttribute('disabled');
      }
    }
  }]);

  return CartUpsellNote;
}(cart_upsell_note_wrapNativeSuper(HTMLElement));

if (!customElements.get('cart-upsell-note')) {
  customElements.define('cart-upsell-note', CartUpsellNote);
}

/* harmony default export */ var cart_upsell_note = ((/* unused pure expression or super */ null && (CartUpsellNote)));
;// CONCATENATED MODULE: ./js/sections/cart-line-upsell-note.js
function cart_line_upsell_note_typeof(obj) { "@babel/helpers - typeof"; return cart_line_upsell_note_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, cart_line_upsell_note_typeof(obj); }

function cart_line_upsell_note_regeneratorRuntime() { "use strict"; cart_line_upsell_note_regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == cart_line_upsell_note_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function cart_line_upsell_note_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cart_line_upsell_note_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cart_line_upsell_note_ownKeys(Object(source), !0).forEach(function (key) { cart_line_upsell_note_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cart_line_upsell_note_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function cart_line_upsell_note_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function cart_line_upsell_note_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function cart_line_upsell_note_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { cart_line_upsell_note_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { cart_line_upsell_note_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function cart_line_upsell_note_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cart_line_upsell_note_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function cart_line_upsell_note_createClass(Constructor, protoProps, staticProps) { if (protoProps) cart_line_upsell_note_defineProperties(Constructor.prototype, protoProps); if (staticProps) cart_line_upsell_note_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function cart_line_upsell_note_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) cart_line_upsell_note_setPrototypeOf(subClass, superClass); }

function cart_line_upsell_note_createSuper(Derived) { var hasNativeReflectConstruct = cart_line_upsell_note_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = cart_line_upsell_note_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = cart_line_upsell_note_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return cart_line_upsell_note_possibleConstructorReturn(this, result); }; }

function cart_line_upsell_note_possibleConstructorReturn(self, call) { if (call && (cart_line_upsell_note_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return cart_line_upsell_note_assertThisInitialized(self); }

function cart_line_upsell_note_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function cart_line_upsell_note_wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; cart_line_upsell_note_wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !cart_line_upsell_note_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return cart_line_upsell_note_construct(Class, arguments, cart_line_upsell_note_getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return cart_line_upsell_note_setPrototypeOf(Wrapper, Class); }; return cart_line_upsell_note_wrapNativeSuper(Class); }

function cart_line_upsell_note_construct(Parent, args, Class) { if (cart_line_upsell_note_isNativeReflectConstruct()) { cart_line_upsell_note_construct = Reflect.construct.bind(); } else { cart_line_upsell_note_construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) cart_line_upsell_note_setPrototypeOf(instance, Class.prototype); return instance; }; } return cart_line_upsell_note_construct.apply(null, arguments); }

function cart_line_upsell_note_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function cart_line_upsell_note_isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function cart_line_upsell_note_setPrototypeOf(o, p) { cart_line_upsell_note_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return cart_line_upsell_note_setPrototypeOf(o, p); }

function cart_line_upsell_note_getPrototypeOf(o) { cart_line_upsell_note_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return cart_line_upsell_note_getPrototypeOf(o); }

var CartLineUpsellNote = function (_HTMLElement) {
  cart_line_upsell_note_inherits(CartLineUpsellNote, _HTMLElement);

  var _super = cart_line_upsell_note_createSuper(CartLineUpsellNote);

  function CartLineUpsellNote() {
    var _this;

    cart_line_upsell_note_classCallCheck(this, CartLineUpsellNote);

    _this = _super.call(this);
    _this.boundValidate = _this.validate.bind(cart_line_upsell_note_assertThisInitialized(_this));
    _this.boundOnBlur = _this.onBlur.bind(cart_line_upsell_note_assertThisInitialized(_this));
    _this.boundOnInput = _this.onInput.bind(cart_line_upsell_note_assertThisInitialized(_this));
    _this.hasBlurred = false;
    _this.isSaving = false;
    _this.saveTimeout = null;
    return _this;
  }

  cart_line_upsell_note_createClass(CartLineUpsellNote, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.cleanup();
    }
  }, {
    key: "lineKey",
    get: function get() {
      return this.getAttribute('data-line-key');
    }
  }, {
    key: "sectionId",
    get: function get() {
      return this.getAttribute('data-section-id');
    }
  }, {
    key: "textarea",
    get: function get() {
      return this._textarea = this._textarea || this.querySelector('textarea[name="line-upsell-note"]');
    }
  }, {
    key: "errorMessage",
    get: function get() {
      return this._errorMessage = this._errorMessage || this.querySelector('.upsells-note-error');
    }
  }, {
    key: "checkoutButton",
    get: function get() {
      return document.querySelector('button[name="checkout"]');
    }
  }, {
    key: "minLength",
    get: function get() {
      var _window$theme, _window$theme$upsellN, _this$textarea;

      return ((_window$theme = window.theme) === null || _window$theme === void 0 ? void 0 : (_window$theme$upsellN = _window$theme.upsellNoteSettings) === null || _window$theme$upsellN === void 0 ? void 0 : _window$theme$upsellN.minLength) || parseInt((_this$textarea = this.textarea) === null || _this$textarea === void 0 ? void 0 : _this$textarea.getAttribute('data-min-length')) || 10;
    }
  }, {
    key: "maxLength",
    get: function get() {
      var _window$theme2, _window$theme2$upsell, _this$textarea2;

      var max = ((_window$theme2 = window.theme) === null || _window$theme2 === void 0 ? void 0 : (_window$theme2$upsell = _window$theme2.upsellNoteSettings) === null || _window$theme2$upsell === void 0 ? void 0 : _window$theme2$upsell.maxLength) || parseInt((_this$textarea2 = this.textarea) === null || _this$textarea2 === void 0 ? void 0 : _this$textarea2.getAttribute('data-max-length')) || 0;
      return max > 0 ? max : null;
    }
  }, {
    key: "noteValue",
    get: function get() {
      var _this$textarea3;

      return ((_this$textarea3 = this.textarea) === null || _this$textarea3 === void 0 ? void 0 : _this$textarea3.value.trim()) || '';
    }
  }, {
    key: "isNoteValid",
    get: function get() {
      var value = this.noteValue;
      var length = value.length;

      if (length < this.minLength) {
        return false;
      }

      if (this.maxLength && length > this.maxLength) {
        return false;
      }

      return true;
    }
  }, {
    key: "init",
    value: function init() {
      if (!this.textarea) {
        console.warn('CartLineUpsellNote: textarea not found');
        return;
      }

      console.log('CartLineUpsellNote init:', {
        lineKey: this.lineKey,
        textareaValue: this.textarea.value,
        noteValue: this.noteValue,
        debugNote: this.getAttribute('data-debug-note'),
        textareaHTML: this.textarea.outerHTML.substring(0, 200)
      });
      this.attachEventListeners();
      this.validate();
    }
  }, {
    key: "attachEventListeners",
    value: function attachEventListeners() {
      this.textarea.addEventListener('input', this.boundOnInput);
      this.textarea.addEventListener('blur', this.boundOnBlur);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      if (this.textarea) {
        this.textarea.removeEventListener('input', this.boundOnInput);
        this.textarea.removeEventListener('blur', this.boundOnBlur);
      }

      if (this.saveTimeout) {
        clearTimeout(this.saveTimeout);
      }
    }
  }, {
    key: "onInput",
    value: function onInput() {
      var _this2 = this;

      this.validate();

      if (this.saveTimeout) {
        clearTimeout(this.saveTimeout);
      }

      this.saveTimeout = setTimeout(function () {
        if (_this2.isNoteValid) {
          _this2.saveNote();
        }
      }, 1000);
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.hasBlurred = true;
      this.validate();

      if (this.isNoteValid) {
        this.saveNote();
      }
    }
  }, {
    key: "saveNote",
    value: function () {
      var _saveNote = cart_line_upsell_note_asyncToGenerator(cart_line_upsell_note_regeneratorRuntime().mark(function _callee() {
        var _this3 = this;

        var cartResponse, cart, item, sectionsToBundle, body, response, updatedCart;
        return cart_line_upsell_note_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isSaving) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this.isSaving = true;
                _context.prev = 3;
                _context.next = 6;
                return fetch("".concat(theme.routes.cart_url, "?view=json"), cart_line_upsell_note_objectSpread({}, theme.utils.fetchConfig('json', 'GET')));

              case 6:
                cartResponse = _context.sent;
                _context.next = 9;
                return cartResponse.json();

              case 9:
                cart = _context.sent;
                item = cart.items.find(function (i) {
                  return i.key === _this3.lineKey;
                });

                if (item) {
                  _context.next = 13;
                  break;
                }

                throw new Error('Line item not found');

              case 13:
                console.log('Saving note - Before:', {
                  lineKey: this.lineKey,
                  currentProperties: item.properties,
                  noteToSave: this.noteValue
                });
                sectionsToBundle = [];
                document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {
                  bubbles: true,
                  detail: {
                    sections: sectionsToBundle
                  }
                }));
                body = JSON.stringify({
                  id: this.lineKey,
                  properties: cart_line_upsell_note_objectSpread(cart_line_upsell_note_objectSpread({}, item.properties), {}, {
                    _upsell_note: this.noteValue
                  }),
                  sections: sectionsToBundle,
                  sections_url: window.location.pathname
                });
                console.log('Saving note - Request body:', JSON.parse(body));
                _context.next = 20;
                return fetch(theme.routes.cart_change_url, cart_line_upsell_note_objectSpread(cart_line_upsell_note_objectSpread({}, theme.utils.fetchConfig()), {}, {
                  body: body
                }));

              case 20:
                response = _context.sent;

                if (response.ok) {
                  _context.next = 23;
                  break;
                }

                throw new Error('Failed to update cart');

              case 23:
                _context.next = 25;
                return response.json();

              case 25:
                updatedCart = _context.sent;
                console.log('Saving note - After:', {
                  updatedItem: updatedCart.items.find(function (i) {
                    return i.key === _this3.lineKey;
                  }),
                  allItems: updatedCart.items.map(function (i) {
                    return {
                      key: i.key,
                      properties: i.properties
                    };
                  })
                });
                theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                  source: 'cart-line-upsell-note',
                  cart: updatedCart
                });
                this.showSuccessFeedback();
                _context.next = 35;
                break;

              case 31:
                _context.prev = 31;
                _context.t0 = _context["catch"](3);
                console.error('Error saving line upsell note:', _context.t0);
                this.showErrorMessage('Failed to save note. Please try again.');

              case 35:
                _context.prev = 35;
                this.isSaving = false;
                return _context.finish(35);

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 31, 35, 38]]);
      }));

      function saveNote() {
        return _saveNote.apply(this, arguments);
      }

      return saveNote;
    }()
  }, {
    key: "validate",
    value: function validate() {
      var isValid = this.isNoteValid;
      this.updateTextareaFeedback(isValid);

      if (isValid) {
        this.hideErrorMessage();
      } else if (this.hasBlurred && this.noteValue.length > 0) {
        this.showErrorMessage();
      }

      this.updateCheckoutButton();
    }
  }, {
    key: "updateTextareaFeedback",
    value: function updateTextareaFeedback(isValid) {
      if (!this.textarea) return;
      var shouldShowFeedback = this.hasBlurred && this.noteValue.length > 0;

      if (!isValid && shouldShowFeedback) {
        this.textarea.classList.add('note-invalid');
        this.textarea.classList.remove('note-valid');
        this.textarea.setAttribute('aria-invalid', 'true');
      } else if (isValid && this.noteValue.length > 0) {
        this.textarea.classList.remove('note-invalid');
        this.textarea.classList.add('note-valid');
        this.textarea.removeAttribute('aria-invalid');
      } else {
        this.textarea.classList.remove('note-invalid', 'note-valid');
        this.textarea.removeAttribute('aria-invalid');
      }
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage() {
      var customMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!this.errorMessage) return;
      var errorText = customMessage || (theme.strings.upsellNoteError || 'The note must be at least {{ min_length }} characters long').replace('{{ min_length }}', this.minLength);
      this.errorMessage.textContent = errorText;
      this.errorMessage.style.display = 'block';
    }
  }, {
    key: "hideErrorMessage",
    value: function hideErrorMessage() {
      if (!this.errorMessage) return;
      this.errorMessage.style.display = 'none';
    }
  }, {
    key: "showSuccessFeedback",
    value: function showSuccessFeedback() {
      var _this4 = this;

      if (this.textarea) {
        var originalBorder = this.textarea.style.borderColor;
        this.textarea.style.borderColor = 'var(--color-success, #22c55e)';
        setTimeout(function () {
          _this4.textarea.style.borderColor = originalBorder;
        }, 500);
      }
    }
  }, {
    key: "updateCheckoutButton",
    value: function updateCheckoutButton() {
      if (!this.checkoutButton) return;
      var allServiceNotes = document.querySelectorAll('cart-line-upsell-note');
      var allValid = true;
      allServiceNotes.forEach(function (noteElement) {
        if (!noteElement.isNoteValid) {
          allValid = false;
        }
      });

      if (allValid) {
        this.checkoutButton.removeAttribute('disabled');
        this.checkoutButton.removeAttribute('data-upsell-note-pending');
      } else {
        this.checkoutButton.setAttribute('disabled', 'disabled');
        this.checkoutButton.setAttribute('data-upsell-note-pending', 'true');
      }
    }
  }]);

  return CartLineUpsellNote;
}(cart_line_upsell_note_wrapNativeSuper(HTMLElement));

if (!customElements.get('cart-line-upsell-note')) {
  customElements.define('cart-line-upsell-note', CartLineUpsellNote);
}

/* harmony default export */ var cart_line_upsell_note = ((/* unused pure expression or super */ null && (CartLineUpsellNote)));
;// CONCATENATED MODULE: ./js/theme.js






}();
/******/ })()
;